//import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { gsap } from 'gsap';
//import DOMHelpers from '../utils/dom-helpers';


export default class{

    constructor( options ) {
        this.defaults = {
        	el:                    false,
            main:                  false,
            urlMode:               false,

            debug:                  false

        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'select-component';
		this.el 			= 	this.options.el;
		this.main			=   this.options.main;

        this.header         = this.el.querySelector( '.header' );
        this.check          = this.header.querySelector( '.check' );
        this.label          = this.header.querySelector( 'label' );
        this.dropdown       = this.el.querySelector( '.dropdown-list' );
        this.options        = this.el.querySelectorAll( '.dropdown-list a' );
        this.className      = 'select-component';

		this.init( true );
    }

    init( b ){
    	this.addEvents( b );
        if ( b ){   
            this.checkIfSelected();
            this.setSize();
            if ( this.options.debug ) this.load_artworks_grid();
        }
       
	}

    log(str){
        console.log( this.namespace + ' :: ' + str );
    }

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
            this.header.addEventListener( 'click', this.onClickHeader );
            //this.options.addEventListener( 'click', this.onSelectOption );
            this.dropdown.addEventListener( 'click', this.onClickOption );

            if ( this.check ){
                this.check.addEventListener( 'click', this.onCheckClick );
            }
		}
		else{
            this.header.removeEventListener( 'click', this.onClickHeader );
            //this.options.reomveEventListener( 'click', this.onSelectOption );
            this.dropdown.removeEventListener( 'click', this.onClickOptionn );

            if ( this.check ){
                this.check.removeEventListener( 'click', this.onCheckClick );
            }
        }
	}

    checkIfSelected(){
        this.value = this.options[0].getAttribute( 'data-value' );
        this.options.forEach( a => {
            if ( a.classList.contains( 'selected' ) ){
                this.setSelection( a );
            }
        });
    }

    onCheckClick = (e)=>{
        e.stopImmediatePropagation();
        this.onSelectOption( this.options[0] );
    }

    onClickOption = ( e )=>{

        if ( e.target.tagName.toLowerCase() !== 'a' ) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        const selectedOption = e.target;

        this.onSelectOption( selectedOption );

    }

    onSelectOption = ( selectedOption )=>{

        if ( this.setSelection( selectedOption ) ){

			// trigger event
			const event = new CustomEvent('select-change', {detail: {text: this.label, val:this.value }});
			this.el.dispatchEvent(event);		

			if ( this.options.urlMode ){
				this.main.barba_triggerURL( this.value, selectedOption );
			}
        }

   }

    setSelection( selectedOption ){

        const value = selectedOption.getAttribute( 'data-value' );
        const label = selectedOption.textContent;

        if ( this.value !== value ){
            // clear class list
            this.options.forEach( a => {
                a.classList.remove( 'selected' );
            });
            selectedOption.classList.add( 'selected' );

            // set value
            this.setValue( value );

            // set label
            this.setLabel( value==='all' ? this.el.getAttribute( 'data-label' ) : label );

            this.open( false );

            return true;
        }

        return false;
    }

    setLabel( label ){
        gsap.from( this.label, { opacity:0, duration:0.8, ease: 'power.out'} );
        this.label.textContent = label;
    }

    setValue( value ){
        this.value = value;
        if ( value !== 'all' ){
            this.el.classList.add( 'is-selected' );
        }
        else{
            this.el.classList.remove( 'is-selected' );
        }
    }

    setSize(){
         this.dropdown.style.height = this.dropdown.querySelector( 'ul' ).getBoundingClientRect().height + 'px';
    }

    getValue(){
        return this.value;
    }

    getLabel(){
        return this.label;
    }

    onClickHeader = (e)=>{
        //e.preventDefault();
        //e.stopImmediatePropagation();
        this.toggle();
    }

    addClickOut( b ){
        if ( b ){
            document.addEventListener( 'click', this.clickOut )
        }
        else{
            document.removeEventListener( 'click', this.clickOut )
        }
    }

    clickOut = ( e ) => {

        //console.log( e );

        // Check if the clicked element (event.target) is NOT inside myElement
        if ( !this.el.contains(e.target)  ) {
            this.open( false );
        }   
        /*
        if ( !e.target.closest( '.' + this.className )) {
            this.open( false );
        }
        */
    }


    toggle(){
        this.open( ! this.el.classList.contains( 'open' ) )
    }

    open( b ){
        //this.main.pauseScroll(b);
        if ( b ){
            this.el.classList.add( 'open' );
        }
        else{
            this.el.classList.remove( 'open' );
        }
        this.addClickOut( b );
    }


    //-------------------------------------------- [ AJAX CALL ]---------------------------------------------------//
    load_artworks_grid( orderby='menu_order', order='ASC', is_raku_collection=true ){

        // localized variables (see _framework/routes.php for ajax implementation and localization )
        const url = window.fondation_trahan_ajax_handler.ajax_url;
        const nonce = window.fondation_trahan_ajax_handler.nonce;

        if ( !url || !nonce ){
            return;
        }

        const id_container = 'grd-artworks', 
              responseContainer = document.getElementById( id_container );

        if ( !responseContainer ){
            return;
        }

        this.setLoadingAjaxCall( true, responseContainer );

        // Prepare the form data layout WordPress requires
        const formData = new URLSearchParams();
        formData.append('action', 'get_artworks_html_grid');
        formData.append('security', nonce );

        formData.append('orderby', orderby);
        formData.append('order', order);
        formData.append('is_raku_collection', is_raku_collection );

    
        // Execute the native async HTTP Request
        fetch( url , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text(); // Read the server response stream as plain text (HTML string)
        })
        .then(htmlMarkup => {
            // Inject the raw HTML directly into the DOM container

            // 1. Create the parser instance
            const parser = new DOMParser();

            // 2. Parse the string as 'text/html'
            const doc = parser.parseFromString(htmlMarkup, 'text/html');

            // 3. check if we find the new content
            const newcontainer = doc.getElementById( id_container );

            if ( newcontainer ){
            
                // 4. Attach the new elements ordered to the grid
                responseContainer.innerHTML = newcontainer.innerHTML;

                // 5. to render the images !!!
                this.main.EFFEX.checkImagesInView();

            }

            // console.log( htmlMarkup );
            this.setLoadingAjaxCall( false, responseContainer );
        })
        .catch(error => {
            console.error('AJAX Error:', error);
            this.setLoadingAjaxCall( false, responseContainer );
        });

    }

    setLoadingAjaxCall( b, responseContainer ){
        this.main.setLoading( b );
        gsap.killTweensOf( responseContainer );
        gsap.to( responseContainer, { opacity: b?0:1, ease: 'power1.out', duration: b?0.4:0.6 } );
    }
    //-------------------------------------------- [ AJAX CALL ]---------------------------------------------------//



    destroy(){
        this.addClickOut( false );
		this.init( false );
    }

}


